import type { Pagination, PaginationParams } from '@app/types/pagination'

export const getPaginationParams = (pagination: Pagination): PaginationParams => {
  const { current, pageSize: limit } = pagination
  const offset = (current - 1) * limit

  return { offset, limit }
}
